import { convertFilterOptions } from '../../../../utils';

import {
     ATTACHED_EVENT,
     CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS,
     CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS,
     DELETE_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS,
     SET_FILTER_CATEGORY,
     SET_SUBSCRIBER_SELLING_GROUPS,
     SET_SUBSCRIBER_SELLING_GROUP_CATEGORIES,
     SET_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS,
     SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS,
     SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_SEARCH,
     SET_TIMEZONE,
     UPDATE_SUBSCRIBER_SELLING_GROUP_FILTER_OPTION,
} from './actions';

const INITIAL_STATE = [];
const INITIAL_STATE_TIMEZONE = null;

const INIT_STATE_ATTACHED = {
     listEventsOptionsAttached: [],
};

export const INITIAL_STATE_SELLING_GROUP_FILTER = {
     'Training Level': [],
     'Training Method': [],
     'Training For': [],
     Language: [],
};

const INITIAL_STATE_SELLING_GROUP_SELECTED = {
     search: '',
     items: [],
};

export const sellingGroupsReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_SELLING_GROUPS: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const sellingGroupCategoriesReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_SELLING_GROUP_CATEGORIES: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const sellingGroupFilterOptionReducer = (state = INITIAL_STATE_SELLING_GROUP_FILTER, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS: {
               return action.payload;
          }
          case UPDATE_SUBSCRIBER_SELLING_GROUP_FILTER_OPTION: {
               const { category, body } = action.payload;

               return {
                    ...state,
                    [category]: [...state[category], body],
               };
          }
          case CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS: {
               const newSellingGroupFilterOptions = {};
               Object.entries(state).forEach(([key, options]) => {
                    newSellingGroupFilterOptions[key] = convertFilterOptions(options);
               });

               return newSellingGroupFilterOptions;
          }
          default:
               return state;
     }
};

export const sellingGroupFilterSelectedReducer = (state = INITIAL_STATE_SELLING_GROUP_SELECTED, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_SEARCH: {
               return {
                    ...state,
                    search: action.payload,
               };
          }
          case SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS: {
               return {
                    ...state,
                    items: action.payload,
               };
          }
          case DELETE_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS: {
               const newSelectedItems = [...state.items].filter((item) => item.value !== action.payload.value);

               return {
                    ...state,
                    items: newSelectedItems,
               };
          }
          case CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS: {
               return { ...state, items: [] };
          }
          default:
               return state;
     }
};

export const filterCategoryReducer = (state = null, action) => {
     switch (action.type) {
          case SET_FILTER_CATEGORY: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const timezoneReducer = (state = INITIAL_STATE_TIMEZONE, action) => {
     switch (action.type) {
          case SET_TIMEZONE: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const attachedEvents = (state = INIT_STATE_ATTACHED, action) => {
     switch (action.type) {
          case ATTACHED_EVENT: {
               return {
                    ...state,
                    listEventsOptionsAttached: action.payload,
               };
          }
          default:
               return state;
     }
};
